import React from 'react';

function Fries() {
    return(
        <div class="menuList">
            <div className="wing-container">
        <div className="col">Sharky Fries</div> <div className="dots"></div>{" "}
        <div className="col">$9.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Scampi Fries</div> <div className="dots"></div>{" "}
        <div className="col">$9.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Cheese Fries</div> <div className="dots"></div>{" "}
        <div className="col">$6.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Maryland Fries</div> <div className="dots"></div>{" "}
        <div className="col">$9.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Buffalo Fries</div> <div className="dots"></div>{" "}
        <div className="col">$8.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Nacho Fries</div> <div className="dots"></div>{" "}
        <div className="col">$9.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Country Fries</div> <div className="dots"></div>{" "}
        <div className="col">$9.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Truffle Parmesan Fries</div> <div className="dots"></div>{" "}
        <div className="col">$10.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Steak Fries</div> <div className="dots"></div>{" "}
        <div className="col">$6.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Curly Fries</div> <div className="dots"></div>{" "}
        <div className="col">$6.99</div>
      </div>
      <div className="wing-container">
        <div className="col">Sweet Potato Fries</div> <div className="dots"></div>{" "}
        <div className="col">$7.99</div>
      </div>
        </div>
    )
}

export default Fries